// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ViewSwitcher_wrap__zQiZJ"};